<button mat-mini-fab class="modify decrease" (click)="decrease()">
  <img src="../../../assets/svg/arrow-left.svg" width="32" height="32" />`
</button>
<span class="date-label">{{ date | date: 'y' }}</span>
<!---->
<button mat-mini-fab class="modify increase" (click)="increase()">
  <img src="../../../assets/svg/arrow-right.svg" width="32" height="32" />`
</button>
